import { Action } from 'redux';

import { SetLayoutType } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { LayoutType } from '../state/LayoutType';


export interface SetLayoutTypeAction extends Action {
  layoutType: LayoutType;
}

export function setLayoutType(layoutType: LayoutType): SetLayoutTypeAction {
  return {
    type: SetLayoutType,
    layoutType: layoutType
  };
}

export const isSetLayoutTypeAction = isActionFactory<SetLayoutTypeAction>(SetLayoutType);
